exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  margin: 0;\n  padding: 0;\n  font-family: sans-serif; }\n\n.app {\n  height: 100vh;\n  max-height: 100vh; }\n\n.mocks * {\n  z-index: 100; }\n\n.devbtn {\n  margin: 10px;\n  background: white; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./dev/styles.css
// module id = 1302
// module chunks = 0